import { Icon } from "@atoms/icon";
import React, { FC, PropsWithChildren } from "react";
import styled from "styled-components";


export const ListItem: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container>
      <Icon name="check" />
      {children}
    </Container>
  );
};

const Container = styled.li`
  display: flex;
  padding: 0;
  margin: 0;
  gap: 0.5em;
  align-items: center;
  .fh-icon {
    color: #fdbb30;
    font-size: 1.5em;
  }
`;
